
import React from 'react';

const About = () => {
  return (
    <section id="about" className="section-padding gradient-bg">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-maroon mb-6">
              Meet Kristen
            </h2>
            <div className="space-y-5 text-lg text-charcoal-light">
              <p>
                Hi, I'm Kristen Tangarone. I'm a Business Operations Consultant and Fractional COO 
                specializing in process optimization, leadership development, and data-driven strategy.
              </p>
              <p>
                With extensive experience in operations leadership roles, I've successfully championed operational 
                excellence, managed high-performing teams, and implemented strategic growth initiatives across 
                various industries.
              </p>
              <p>
                I partner with growth-stage businesses to enhance operational efficiency, 
                drive strategic growth, and build sustainable success through streamlined processes
                and effective leadership development.
              </p>
              <p className="font-medium text-charcoal">
                If you're facing operational challenges, need leadership guidance, 
                or seek data-driven strategies to optimize your business, I'm here to help you
                achieve your goals and reach new heights.
              </p>
            </div>
          </div>
          <div className="order-1 lg:order-2 flex justify-center">
            <div className="relative">
              <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-white shadow-xl">
                <img 
                  src="/lovable-uploads/8b86445a-c5e9-4eff-b7ee-520ab183dc3c.png" 
                  alt="Kristen Tangarone" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-maroon/10 rounded-full"></div>
              <div className="absolute -top-6 -left-6 w-32 h-32 bg-maroon/10 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
